/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { Record } from 'immutable'
import { PasswordResetActionTypes } from '../../action/user/PasswordResetActions'

const PasswordResetUpadateState = Record({
  password: '',
  passwordConf: '',
  isSamePassword: true,
  isPasswordUpdated: false
})

class PasswordResetUpdateStore extends ReduceStore<State, Action> {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new PasswordResetUpadateState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case PasswordResetActionTypes.handlePasswordEdit:
        return state.set(payload.name, payload.value)
      case PasswordResetActionTypes.passwordUpdated:
        return state.merge({ isPasswordUpdated: true })
      default:
        return state
    }
  }
}

export default new PasswordResetUpdateStore()
